import { memo, useMemo } from 'react';
import { View } from 'foundations-components/components/View';
import { InlineMediaPlayerProvider } from 'recording-review-components-lib/media-player/variant-inline/InlineMediaPlayerProvider';
import { MediaPlayer } from './MediaPlayer';
import { jsx as _jsx } from "react/jsx-runtime";
const MediaPlayerWrapper = ({
  callMessage,
  duration,
  engagementId,
  hasVoicemail,
  onDeleteRecording,
  recordingUrl
}) => {
  const audioDurationInSeconds = useMemo(() => duration / 1000, [duration]);
  return /*#__PURE__*/_jsx(View, {
    "data-selenium-test": "call-recording",
    paddingBlockEnd: "600",
    children: /*#__PURE__*/_jsx(InlineMediaPlayerProvider, {
      audioDurationInSeconds: audioDurationInSeconds,
      engagementId: engagementId,
      source: null,
      src: recordingUrl,
      children: /*#__PURE__*/_jsx(MediaPlayer, {
        callMessage: callMessage,
        engagementId: engagementId,
        hasVoicemail: hasVoicemail,
        onDeleteRecording: onDeleteRecording
      })
    })
  });
};
export default /*#__PURE__*/memo(MediaPlayerWrapper);